// extracted by mini-css-extract-plugin
export default {"faqLink":"FAQLink_faqLink__w98iZ","descriptionLine":"FAQLink_descriptionLine__VwNDm","faqSection":"FAQLink_faqSection__+0-Un"};